"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function SttSkeleton(props) {
  return /*#__PURE__*/_react["default"].createElement(_Skeleton["default"], props);
}
var _default = SttSkeleton;
exports["default"] = _default;